export const getSongAudioAddress = (songId) =>
  `${process.env.SONG_FILE_URL}/seance_${songId}/track.mp3`

export const getSongImageAddress = (imageName) =>
  `${process.env.SONG_IMAGE_URL}/${imageName}`

export const getImmersiveVideoUrl = (fileName) =>
  `${process.env.CLOUD_FRONT_IMMERSIVE_VIDEO}/${fileName}`

export const getImmersiveThumbUrl = (fileName) =>
  `${process.env.CLOUD_FRONT_IMMERSIVE_THUMB}/${fileName}`

export const getWelcomeUrl = (fileName) =>
  `${process.env.CLOUD_FRONT_WELCOME}/${fileName}`

export const getTrainingUrl = (fileName) =>
  `${process.env.CLOUD_FRONT_TRAINING}/${fileName}`
